import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

import Breadcrumbs from "components/Breadcrumbs"
import { Container } from "components/Page"

//
import { DateRangeFilter } from "../filters/DateRangeFilter"
import { QuartersFilter } from "../filters/Quarters"
//

import Indicators from "./1_Indicators"
import SpendByMarket from "./2_SpendByMarket"
import MarketMediaMixHeatmap from "./3_MarketMediaMixHeatmap"
import MarketSummary from "./4_MarketSummary"

const styles = {
  header: css`
    padding: var(--spacing-s, 12px) 0;
    min-height: 32px;
    display: flex;
    align-items: center;
  `,
  title: css`
    color: var(--black);
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    margin-inline-end: var(--spacing-m, 1rem);
  `,
  space: css`
    flex: 1;
  `,

  contentContainer: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-m, 1rem);
  `,
}

export default function Regional() {
  const { t } = useI18n()
  return (
    <Container>
      <Breadcrumbs section={t("nav.dashboard")} current={t("nav.regional")} />
      <header className={styles.header}>
        <h1 className={styles.title}>{t("nav.regional")}</h1>
        <div className={styles.space} />
        <Filters />
      </header>
      <div className={styles.contentContainer}>
        <Indicators />
        <SpendByMarket />
        <MarketMediaMixHeatmap />
        <MarketSummary />
      </div>
    </Container>
  )
}

function Filters() {
  return (
    <div
      className={css`
        display: flex;
        gap: var(--spacing-xss, 8px);
        align-items: center;
      `}
    >
      {/* <MarketFilter /> */}

      <QuartersFilter />
      <DateRangeFilter />
    </div>
  )
}
